import { render, staticRenderFns } from "./DialogVincularContrato.vue?vue&type=template&id=765747e1&scoped=true&"
import script from "./DialogVincularContrato.vue?vue&type=script&lang=js&"
export * from "./DialogVincularContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765747e1",
  null
  
)

export default component.exports